import { render, staticRenderFns } from "./OrganizationExpensePeriods.vue?vue&type=template&id=221b8b20"
import script from "./OrganizationExpensePeriods.vue?vue&type=script&lang=js"
export * from "./OrganizationExpensePeriods.vue?vue&type=script&lang=js"
import style0 from "./OrganizationExpensePeriods.vue?vue&type=style&index=0&id=221b8b20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports